import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { shouldUseAppConfigForEnvironment } from '../helpers/environments';
import { AppConfig } from 'src/app/app-config';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceGuard implements CanActivate {

  constructor(private router: Router, private appConfig: AppConfig) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    let inMaintenanceMode: boolean = false;

    if (shouldUseAppConfigForEnvironment(this.appConfig && this.appConfig.config && this.appConfig.config.environment)) {
      inMaintenanceMode = this.appConfig.config.maintenance;
    } else {
      inMaintenanceMode = environment.maintenance;
    }

    if(inMaintenanceMode) {
      this.router.navigateByUrl('maintenance');
      return false;
    } else {
      return true
    }
  }
}
